import styles from "./ua.module.scss";

export default function FormCells(props) {
  return <div className={ styles.cells }>{ props.children }</div>
}
